import { getRoute } from "@utils/route";

export const PRIVACY_POLICY_PAGE_URL = '/privacy-policy';

export const routePrivacyPolicyPage = () => getRoute(PRIVACY_POLICY_PAGE_URL);
